import IconBase from "./IconBase";

// A tag: the string variant that addresses the entry in a URL.
const SlugIcon = (props) => (
    <IconBase {...props}>
        <path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.83 0l-7.4-7.4a2 2 0 0 1-.57-1.4V4.6a2 2 0 0 1 2-2h7.2a2 2 0 0 1 1.41.59l7.4 7.4a2 2 0 0 1 0 2.82Z" />
        <circle cx="7.75" cy="7.75" r="1.4" />
    </IconBase>
);

export default SlugIcon;
